<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <p>Please select your intended major.</p>
        <v-select v-model="major" :items="majors" :rules="[v => !!v || 'Major is Required']" label="Intended Major"></v-select>
        <v-checkbox v-model="declareSecondMajor" label="I would like to pursue a double major (this is optional)"></v-checkbox>
        <v-select v-if="declareSecondMajor" v-model="secondMajor" :items="majors" :rules="[v => !!v || !declareSecondMajor || 'Required when pursuing a double major is selected']" label="Second Major"></v-select>
        <v-checkbox v-model="declareMinor" label="I would like to add a minor (optional; can also be done later if you decide to)"></v-checkbox>
        <v-select v-if="declareMinor" v-model="minor" :items="minors" :rules="[v => !!v || !declareMinor || 'Required when adding a minor is selected']" label="Minor"></v-select>
        <v-checkbox v-model="declareCertificate" label="I would like to pursue a certificate (optional)"></v-checkbox>
        <v-select v-if="declareCertificate" v-model="certificate" :items="certificates"  :rules="[v => !!v || !declareCertificate || 'Required when pursuing a certificate is selected']" label="Certificate"></v-select>
        <v-divider class="mb-2 mt-1"></v-divider>
        <v-alert type="info">Placement Tests are all online and must be completed prior to submitting your pre-registration form.</v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="next()">Continue</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref, onMounted } from '@vue/composition-api'
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const form = ref(null)

    const majors = ref([])
    const minors = ref([])
    const certificates = ref([
      'Certificate in Arts Administration',
      'Certificate in Entrepreneurship',
      'Certificate in Environmental Stewardship and Sustainability',
      'Certificate in Journalism and Society',
      'Certificate in Medical Ethics Consultation',
      'Certificate in Neuroscience',
      'Certificate in Teaching English to Speakers of Other Languages (TESOL)'
    ])

    onMounted(() => {
      const service = root.$feathers.service('forms/select-options')
      service.find({ query: { name: 'Major Code (Pre-Reg)' } }).then(({ data }) => {
        if (data.length > 0) {
          service.get(data[0].value).then(({ options }) => {
            majors.value = options
          })
        }
      })
      service.find({ query: { name: 'Minor Code (Pre-Reg)' } }).then(({ data }) => {
        if (data.length > 0) {
          service.get(data[0].value).then(({ options }) => {
            minors.value = options
          })
        }
      })

      if ('major' in props.data) major.value = props.data.major
      if ('secondMajor' in props.data) secondMajor.value = props.data.secondMajor
      if ('minor' in props.data) minor.value = props.data.minor
      if ('certificate' in props.data) certificate.value = props.data.certificate
    })

    const major = ref('')
    const secondMajor = ref('')
    const minor = ref('')
    const certificate = ref('')

    const declareSecondMajor = ref(false)
    const declareMinor = ref(false)
    const declareCertificate = ref(false)

    function next () {
      if (form.value.validate()) {
        let obj = { major: major.value }
        if (declareSecondMajor.value) obj.secondMajor = secondMajor.value
        if (declareMinor.value) obj.minor = minor.value
        if (declareCertificate.value) obj.certificate = certificate.value
        emit('next', obj)
      }
    }

    return {
      form,
      majors,
      minors,
      certificates,
      major,
      secondMajor,
      minor,
      certificate,
      declareSecondMajor,
      declareMinor,
      declareCertificate,
      next
    }
  }
}
</script>
